import { LogManager } from "./LogManager";

export enum ErrorCategory {
  Network = "Network",
  Payment = "Payment",
  UI = "UI",
}

export enum ErrorSeverity {
  /** Real failures worth reviewing in the Admin panel (persisted to the backend). */
  Error = "Error",
  /** Low-value / transient noise (empty responses, missing JSON). Console only. */
  Warning = "Warning",
}

/**
 * Logs a client-side error to the console and — for `Error` severity — persists it on the backend
 * (best-effort), so it can be reviewed in the Admin panel. Never throws.
 *
 * `Warning` severity is console-only: it is meant for structural/transient network noise (e.g.
 * empty responses with no JSON) that would otherwise flood the Admin error log.
 */
export const logError = async (
  category: ErrorCategory,
  message: string,
  params?: unknown,
  severity: ErrorSeverity = ErrorSeverity.Error,
): Promise<void> => {
  console.log(`>>>> [${severity}] `, message, params ?? "");

  if (severity !== ErrorSeverity.Error) return;

  // Best-effort backend persistence. LogManager uses raw fetch and swallows failures,
  // so this can never loop back into logError or break the caller.
  void LogManager.getManager().logClientError({
    message,
    category,
    context: params,
  });
};
